import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { CheckEmailPage } from '../pages/Auth/CheckEmailPage'

export const Route = createFileRoute('/check-email')({
  component: CheckEmailRoute,
})

function CheckEmailRoute() {
  const navigate = useNavigate()

  return (
    <CheckEmailPage
      onBackToLogin={() => {
        navigate({ to: '/login' })
      }}
    />
  )
}
